export default "__VITE_ASSET__98e9d03c__"